<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Users</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="openSearch">Search</a>
          </div>
          <div class="items-per-page-dropdown mb-3">
            <label>Items Per Page: </label>
            <select v-model="size" @change="updateItemsPerPage">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('userId')">User Id</th>
              <th class="col-1" @click="toggleSort('email')">Email</th>
              <th class="col-1" @click="toggleSort('loginId')">Login Id</th>
              <th class="col-1" @click="toggleSort('emailSubscribe')">Email Subscribe</th>
              <th class="col-1" @click="toggleSort('role')">Role</th>
              <th class="col-1" @click="toggleSort('region')">Region</th>
              <th class="col-1" @click="toggleSort('videoQuality')">Video Quality</th>
              <th @click="toggleSort('status')">Status</th>
              <th @click="toggleSort('active')">Active</th>
              <th @click="toggleSort('emailCleanStatus')">Email Clean Status</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.userId">
              <td class="col-1 text-truncate" v-html="truncateText(config.userId, 50)"  @click="selectText" :data-text="config.userId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.email, 30)"  @click="selectText" :data-text="config.email" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.loginId, 30)" @click="selectText" :data-text="config.loginId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.emailSubscribe, 10)" @click="selectText" :data-text="config.emailSubscribe"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.role, 10)" @click="selectText" :data-text="config.role"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.region, 10)" @click="selectText" :data-text="config.region"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.videoQuality, 10)" @click="selectText" :data-text="config.videoQuality"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.status, 10)" @click="selectText" :data-text="config.status"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 10)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.emailCleanStatus, 10)" @click="selectText" :data-text="config.emailCleanStatus"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'UserEdit', params: { id: config.userId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <vue-awesome-paginate
            :total-items="totalElements"
            :items-per-page="size"
            :max-pages-shown="5"
            v-model="page"
            :on-click="changePage"
        />
      </div>
    </div>
    <!-- Modal -->
    <div class="modal d-block" v-if="showSearch">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Search in users</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <label>User id</label>
              <input type="text" v-model="searchFilters.userId">
              <label >User email</label>
              <input type="text" v-model="searchFilters.email">
              <label>Email subscribe</label>
              <input type="text" v-model="searchFilters.emailSubscribe">
              <label >Role</label>
              <input type="text" v-model="searchFilters.role">
              <label>Region</label>
              <input type="text" v-model="searchFilters.region">
              <label >Video quality</label>
              <input type="text" v-model="searchFilters.videoQuality">
              <label>Active</label>
              <input type="text" v-model="searchFilters.active">
              <label >Status</label>
              <input type="text" v-model="searchFilters.status">
              <label >Email Cleanup Status</label>
              <input type="text" v-model="searchFilters.emailCleanStatus">
            </form>
            <div v-if="modalError" class="error-message mt-3 pe-3">{{modalError}}</div>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeSearch">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="doLoadData">Search</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import {UserRequest, Sort, UserFilter} from "@/model/models";

export default {
  name: "Users",
  components: {
    Header,
  },
  data() {
    return {
      showSearch: false,
      page: 1,
      size: 20,
      totalElements: 0,
      UsersList: [],
      sortColumn: null,
      sortDirection: "ASC",
      searchFilters: new UserFilter(null,null,null,null,null,null,null,null, null),
      modalError: null
    };
  },
  computed: {
    sortData() {
      return this.UsersList;
    },
  },
  created() {
    this.doLoadData();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));
  },
  methods: {
    changePage(page) {
      this.page = page
      this.doLoadData()
    },
    doLoadData() {
      let request = new UserRequest(
          this.page - 1,
          this.size
      );
      if (this.sortColumn != null) {
        request.sort = new Sort(this.sortColumn, this.sortDirection);
      }
      request.filter = new UserFilter(
          this.searchFilters.userId, this.searchFilters.email, this.searchFilters.role, this.searchFilters.emailSubscribe,
          this.searchFilters.region, this.searchFilters.videoQuality, this.searchFilters.status, this.searchFilters.active, this.searchFilters.emailCleanStatus
      );

      AdminService.getUsersList(request).then((data) => {
        this.closeSearch()
        this.UsersList = data.userList;
        this.page = data.page + 1
        this.totalElements = data.totalElements
        this.searchFilters = new UserFilter(
            data.filter.userId, data.filter.email, data.filter.role, data.filter.emailSubscribe,
            data.filter.region, data.filter.videoQuality, data.filter.status, data.filter.active, data.filter.emailCleanStatus
        );
      }).catch((error) => {
        console.log(error)
        if (error.response && error.response.data && error.response.data.message) {
          this.modalError = error.response.data.message;
        }
      });
    },
    closeSearch() {
      this.searchFilters = new UserFilter(null,null,null,null,null,null,null,null, null)
      this.showSearch = false
      this.modalError=null
    },
    openSearch() {
      this.searchFilters = new UserFilter(null,null,null,null,null,null,null,null, null)
      this.page = 1
      this.showSearch = true
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      await navigator.clipboard.writeText(originalText);
      this.highlightElement(event.target);
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'ASC';
      }
      this.doLoadData()
    },
    updateItemsPerPage() {
      this.doLoadData()
    },
    applyFilter(column) {
      const filterValue = this.searchFilters[column].toLowerCase();
      const filteredData = this.dataRows.filter(row => {
        return row[column].toLowerCase().includes(filterValue);
      });
      this.dataRows = filteredData;
    },
  },
  mounted() {
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.showSearch) {
        this.closeSearch();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('keyup', this.closeSearch);
  }
};
</script>
<style src="../../assets/style.css">
</style>
